module.exports = __webpack_public_path__ + "img/project_10.78a26b3e.png";